
const masterpassReviewStepConfig = {
    component: () => import('./MasterpassReview'),
    flow: 'postBuy'
};

export default masterpassReviewStepConfig;
